import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(private http: HttpClient) { }

  
  get(path: string, params: HttpParams = new HttpParams()): Observable<any> 
  {
    const requestOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params:params
    };
    return this.http.get(`${ environment.apiUrl }${ path }`, requestOptions);

  }

  
  put(path: string, body: Object = {}): Observable<any> 
  {
    return this.http.put(`${ environment.apiUrl }${ path }`, JSON.stringify(body));
  }

  
  post(path: string, body: Object = {}, params: HttpParams = new HttpParams()): Observable<any> 
  {
  
    const requestOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params:params
    };
    return this.http.post(`${ environment.apiUrl }${ path }`, JSON.stringify(body), requestOptions);
  }

  postWithBlobResponse(path: string, body: Object = {}, params: HttpParams = new HttpParams()): Observable<Blob> 
  {
   const requestOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    params: params,
    responseType: 'blob' as 'json' // TypeScript quirk to satisfy typings
  };

  return this.http.post<Blob>(`${environment.apiUrl}${path}`, JSON.stringify(body), requestOptions);

  }

  
  delete(path: string, params: HttpParams = new HttpParams()): Observable<any> 
  {
    
    const requestOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params:params
    };
    return this.http.delete(`${ environment.apiUrl }${ path }`,requestOptions);
  }

  
  patch(path: string, params: HttpParams = new HttpParams(),body: Object ={}): Observable<any> 
  {
    const requestOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params:params
    };
    return this.http.patch(`${ environment.apiUrl }${ path }`, JSON.stringify(body),requestOptions);
  }
}
